import React from 'react';

function RecoverMifsManually() {
  return <div>RecoverMifsManually</div>;
}

export default RecoverMifsManually;
